module.exports = __webpack_public_path__ + "assets/delete_icon-ac562b.svg";